import React, { Dispatch, SetStateAction } from 'react';
import { useSelector } from 'react-redux';
import SpaceUtilizationWidget from './SpaceUtilizationWidget';
import BarGraph from '../../../../graphs/BarGraph';
import { DateRange } from '../../../../redux/dateRangeSlice';
import { ChartDataPoint } from '../../../../graphs/axisUtils';

interface OccupancyBarGraphProps {
  barGraphData: ChartDataPoint[],
  selectedDayIndex?: number,
  setSelectedDayIndex?: Dispatch<SetStateAction<number>>,
  capacity: number,
}

const OccupancyBarGraph = ({
  barGraphData, selectedDayIndex, setSelectedDayIndex, capacity,
}: OccupancyBarGraphProps) => {
  const range: DateRange = useSelector((state: { dateRange: DateRange }) => state.dateRange);
  const showDayDropdown: boolean = !!setSelectedDayIndex && selectedDayIndex !== undefined
    && ![0, 7].includes(range.selectedRange);
  const title: string = showDayDropdown ? 'Daily average occupancy' : 'Average Occupancy';
  const tooltipText: string = showDayDropdown
    ? 'Shows average occupancy over each hour of the day, for a particular day of the week'
    : 'Shows average occupancy for each time period during the selected date range';

  return <SpaceUtilizationWidget
    content={<BarGraph
      title='People'
      chartHeight={320}
      chartData={barGraphData}
      horizontalTickCount={12}
      xAxisTickFormat={barGraphData ? (t: number) => barGraphData[t]?.date : null}
      {...{ capacity }}
    />}
    {...{
      title, tooltipText, selectedDayIndex, setSelectedDayIndex, showDayDropdown, range,
    }}
    plural={![0, 1, 7].includes(range.selectedRange)}
  />;
};

export default OccupancyBarGraph;
